import { EditDeleteIconComponent } from '../../../shared/common-components/ag-grid/edit-delete-icon/edit-delete-icon.component';
import { AgColDefsI, AgGridI, paginationModel } from '../../../shared/common-components/ag-grid/ag-grid.model';
import { AmountColWidth, WeightColWidth } from '../../../shared/enum/common-enum';
import { CheckboxRendererComponent } from '../../../shared/common-components/ag-grid/checkbox-renderer/checkbox-renderer.component';
import { TextRendererComponent } from '../../../shared/common-components/ag-grid/text-renderer/text-renderer.component';
import { StorageName } from '../../../shared/enum/common-enum';
import { exportRequest } from '../../report/report.model';
import { StorageService } from '../../../shared/services/storage.service';
import { NumericCellRendererComponent } from '../../../shared/common-components/ag-grid/numeric-cell-renderer/numeric-cell-renderer.component';
import { DateCellRendererComponent } from '../../../shared/common-components/ag-grid/date-cell-renderer/date-cell-renderer.component';
import { API_URL_GET_ALL_DIAMONDSTONEPRICING, API_URL_GET_ALL_MAKING_LABOUR_PRICING, API_URL_GET_ALL_MASTERS_CATEGORY } from '../../../shared/url-helper/url-helper';
import { AgGridCustomDropdownComponent } from '../../../shared/common-components/ag-grid/ag-grid-custom-dropdown/ag-grid-custom-dropdown.component';
import { AgGridCustomInputComponent } from '../../../shared/common-components/ag-grid/ag-grid-custom-input/ag-grid-custom-input.component';
import { AgGridCustomSelect2Component } from '../../../shared/common-components/ag-grid/ag-grid-custom-select2/ag-grid-custom-select2.component';

export class Masters {
}

const BranchesListColumnDef: AgColDefsI[] = [
    { headerName: "Branch Name", 
    headerComponentParams: {enableMenu:false},
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'name',
    cellClass:'px-0 custom-column-group-cell text-primary',
    lockPosition:true,
    suppressMovable: false,
    resizable: true, 
    cellRenderer: TextRendererComponent,
    cellRendererParams :{isCursor:true},
    editable:false, 
    minWidth: 180, flex:2,
  },
  // { headerName: "Company ID", 
  //   headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  //   field: 'companyId',
  //   sortable:true,
  //   cellClass:'px-2 custom-column-group-cell', minWidth: 90, flex: 1,
  //   editable:false,
  // },
  { headerName: "Contact", 
    headerClass: "px-1 custom-column-group-cell border-0 text-gray-color f-14 text-gray-color font-semibold ag_header_end",        
    field: 'mobileNumber1',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true, 
    cellRenderer: TextRendererComponent,
    minWidth: 180, flex: 1,
  },
  { headerName: 'Mail ID', 
    sortable:true,
    headerClass: "px-0 custom-column-group-cell h-100 border-0 f-14 text-gray-color font-semibold",
    field: 'email', 
    cellClass:'px-2 custom-column-group-cell',
    editable:false,
    resizable: true,
    minWidth: 180, flex: 2, 
    cellRenderer: TextRendererComponent,
  },
  { headerName: "Address", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'fullAddress',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell f-12',
    editable:false,
    resizable: true, 
    minWidth: 280, flex: 2,
    cellRenderer: TextRendererComponent,
  },
  { headerName: "Status", 
  headerCheckboxSelection: false, 
  headerClass: "custom-column-group-cell px-0",
  field: 'active',  
  sortable:true, 
  cellRenderer: CheckboxRendererComponent, 
  cellRendererParams: { showLabel: false ,isReadOnly:true}, 
  cellClass:'px-2 custom-column-group-cell d-flex justify-content-center', 
  editable:false,
  resizable: true, 
  lockPosition:'right',
  suppressMovable: false,
  minWidth: 75, 
  maxWidth:75 ,
}
  ,
  { headerName: "", 
  editable:false,
  field:'editdeleteicon',
  cellRenderer: EditDeleteIconComponent,
  cellClass:' custom-column-group-cell d-flex align-items-center justify-content-center',
  // cellRendererParams :{focusOnColumn:'name' ,isEditRowOnEdit:false},
  cellRendererParams: (params: any) => {
    const storageService = new StorageService();
    const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
    return {
      hasDeletePermission: userPermissions?.mastersCanDelete,
      focusOnColumn:'name' ,isEditRowOnEdit:false
    };
  },
  headerComponentParams: {deleteThroughApi : true },
  lockPosition:'right',
  suppressMovable: false,
  resizable: false,  
  minWidth: 50, maxWidth:50,
}
  ,
];

const CategoryListColumnDef: AgColDefsI[] = [
  { headerName: "Name", 
    headerComponentParams: {enableMenu:false},
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'nameWithParentCategory',
    cellClass:'px-0 custom-column-group-cell text-primary', 
    editable:false,
    lockPosition:true,
    suppressMovable: false,
    resizable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams :{isCursor:true},
    minWidth: 90, flex:2,
  },
  { headerName: "Short Code", 
    headerComponentParams: {enableMenu:false},
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'shortCode',
    cellClass:'px-0 custom-column-group-cell', 
    editable:false,
    lockPosition:true,
    suppressMovable: false,
    resizable: true,
    cellRenderer: TextRendererComponent,
    minWidth: 70, flex:1,
  },
  { headerName: "Min. Qty.", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'minimumQty',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true, 
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
  },
  { headerName: "Max. Qty.", 
    headerClass: "px-1 custom-column-group-cell border-0 text-gray-color f-14 text-gray-color font-semibold ag_header_end",        
    field: 'maximumQty',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
  },
  { headerName: 'Min. Wt.', 
    sortable:true,
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'minimumGrossWt', 
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isWeight:true},
  },
  { headerName: "Max. Wt.", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'maximumGrossWt',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isWeight:true},
  },
  { headerName: "Status", 
    headerCheckboxSelection: false, 
    headerClass: "custom-column-group-cell px-0",
    field: 'active',  
    sortable:true, 
    cellRenderer: CheckboxRendererComponent,
    cellRendererParams: { showLabel: false ,isReadOnly:true}, 
    cellClass:'px-2 custom-column-group-cell d-flex justify-content-center',
    lockPosition:'right',
    suppressMovable: false,
    resizable: false,  
    editable:false,
    minWidth: 75, 
    maxWidth:75 ,
  }
  ,
  { headerName: "", 
  editable:false,
  field:'editdeleteicon',
  cellRenderer: EditDeleteIconComponent,
  cellClass:' custom-column-group-cell d-flex align-items-center justify-content-center',
  cellRendererParams: (params: any) => {
    const storageService = new StorageService();
    const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
    return {
      hasDeletePermission: userPermissions?.mastersCanDelete,
      focusOnColumn:'name' ,isEditRowOnEdit:true
    };
  },
  headerComponentParams: {deleteThroughApi : true },
  lockPosition:'right',
  suppressMovable: false,
  resizable: false, 
  minWidth: 50, 
  maxWidth:50
}
  ,
];

const BucketListColumnDef: AgColDefsI[] = [
    { headerName: "Name", 
    headerComponentParams: {enableMenu:false},
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'name',
    cellClass:'px-0 custom-column-group-cell text-primary', 
    editable:false,
    lockPosition:true,
    suppressMovable: false,
    resizable: true,
    cellRenderer: TextRendererComponent,
    cellRendererParams :{isCursor:true},
    minWidth: 90, flex:2,
  },
  { headerName: "Min. Qty.", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'minimumQuantity',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true, 
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
  },
  { headerName: "Max. Qty.", 
    headerClass: "px-1 custom-column-group-cell border-0 text-gray-color f-14 text-gray-color font-semibold ag_header_end",        
    field: 'maximumQuantity',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
  },
  { headerName: 'Min. Wt.', 
    sortable:true,
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'minimumWeight', 
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isWeight:true},
  },
  { headerName: "Max. Wt.", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'maximumWeight',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isWeight:true},
  },
  { headerName: "Weight", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'weight',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    editable:false,
    resizable: true,
    minWidth: 70, flex:1,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isWeight:true},
  },
  { headerName: "Status", 
    headerCheckboxSelection: false, 
    headerClass: "custom-column-group-cell px-0",
    field: 'active',  
    sortable:true, 
    cellRenderer: CheckboxRendererComponent,
    cellRendererParams: { showLabel: false,isReadOnly:true }, 
    cellClass:'px-2 custom-column-group-cell d-flex justify-content-center',
    lockPosition:'right',
    suppressMovable: false,
    resizable: false,  
    editable:false,
    minWidth: 75, 
    maxWidth:75 ,
  }
  ,
  { headerName: "", 
  editable:false,
  field:'editdeleteicon',
  cellRenderer: EditDeleteIconComponent,
  cellClass:' custom-column-group-cell d-flex align-items-center justify-content-center',
  // cellRendererParams :{focusOnColumn:'name' ,isEditRowOnEdit:true}, 
  cellRendererParams: (params: any) => {
    const storageService = new StorageService();
    const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
    return {
      hasDeletePermission: userPermissions?.mastersCanDelete,
      focusOnColumn:'name' ,isEditRowOnEdit:true
    };
  },
  headerComponentParams: {deleteThroughApi : true },
  lockPosition:'right',
  suppressMovable: false,
  resizable: false, 
  minWidth: 50, 
  maxWidth:50
}
  ,
];

const TaxSettingListColumnDef: AgColDefsI[] = [
{ headerName: "Name", 
  headerComponentParams: {enableMenu:false},
  sortable:true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'name',
  cellClass:'px-0 custom-column-group-cell text-primary', 
  editable:false,
  lockPosition:true,
  suppressMovable: false,
  resizable: true, 
  cellRenderer: TextRendererComponent,
  cellRendererParams :{isCursor:true},
  minWidth: 80, flex:2,
},
{ headerName: "Applicable On", 
  headerClass: "px-1 custom-column-group-cell border-0 text-gray-color f-14 text-gray-color font-semibold",        
  field: 'applicableOnName',
  sortable:true,
  cellClass:'px-2 custom-column-group-cell',
  minWidth: 80, flex:2,
  editable:false,
  resizable: true,
  cellRenderer: TextRendererComponent,
},
{ headerName: "Rate", 
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  field: 'rate',
  sortable:true,
  cellClass:'px-2 custom-column-group-cell text-end', minWidth: 80,flex:2,
  editable:false,
  resizable: true,
  cellRendererParams: {isRate:true},
  cellRenderer:NumericCellRendererComponent,
},

// 
{ headerName: "Tax Group", 
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'taxGroupName',
  sortable:true,
  cellClass:'px-2 custom-column-group-cell',
  minWidth: 80,flex:2,
  editable:false,
  resizable: true,
  cellRenderer: TextRendererComponent,
},
{ headerName: "Comment", 
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'comment',
  sortable:true,
  cellClass:'px-2 custom-column-group-cell',
  minWidth: 80,flex:2,
  editable:false,
  resizable: true,
  cellRenderer: TextRendererComponent,
},
{ headerName: "Status", 
  headerCheckboxSelection: false, 
  headerClass: "custom-column-group-cell px-0",
  field: 'active',  
  sortable:true, 
  cellRenderer: CheckboxRendererComponent,
  cellRendererParams: { showLabel: false,isReadOnly:true}, 
  cellClass:'px-2 custom-column-group-cell d-flex justify-content-center',
  suppressMovable: false,
  resizable: false, 
  minWidth: 75, 
  maxWidth:75 ,
  editable:false,
}
,
{ headerName: "", 
  editable:false,
  field:'editdeleteicon',
  cellRenderer: EditDeleteIconComponent,
  cellClass:' custom-column-group-cell d-flex align-items-center justify-content-center',
  cellRendererParams: (params: any) => {
    const storageService = new StorageService();
    const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
    return {
      hasDeletePermission: userPermissions?.mastersCanDelete,
      focusOnColumn:'branchName' ,isEditRowOnEdit:true
    };
  },
  headerComponentParams: {deleteThroughApi : true },
  lockPosition:'right',
  suppressMovable: false,
  resizable: false,  
  minWidth: 50, maxWidth:50
}
,
];

const StyleListColumnDef: AgColDefsI[] = [
  { headerName: "Style", 
    headerComponentParams: {enableMenu:false},
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'style',
    cellClass:'px-2 custom-column-group-cell',
    cellRenderer:TextRendererComponent,
    suppressMovable: false,
    resizable: true, 
    editable:false, 
    minWidth: 120, flex:1,
  },
  { headerName: "Category", 
    headerClass: "px-0 custom-column-group-cell border-0 text-gray-color f-14 font-semibold",        
    field: 'categoryName',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell',
    editable:false,
    cellRenderer:TextRendererComponent,
    resizable: true,
    minWidth: 120, flex: 2,
  },
  { headerName: 'Product', 
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'productName', 
    cellClass:'px-2 custom-column-group-cell',
    editable:false,
    resizable: true,
    minWidth: 150, flex: 2, 
    cellRenderer:TextRendererComponent,
  },
  { headerName: "Gross wt.", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'grossWt',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end f-12',
    editable:false,
    resizable: true,
    minWidth: 130,  
    maxWidth: 130,
    cellRenderer:NumericCellRendererComponent,
    cellRendererParams: {isWeight:true},
  }
];

const CreditCardListColumnDef: AgColDefsI[] = [
  { headerName: "Name", 
  headerComponentParams: {enableMenu:false},
  sortable:true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'name',
  cellClass:'px-0 custom-column-group-cell text-primary', 
  editable:false,
  lockPosition:'left',
  resizable: true,
  cellRenderer: TextRendererComponent,
  cellRendererParams :{isCursor:true},
  minWidth: 200, flex:2,
},
{ headerName: "Account Group", 
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'accountLedgerName',
  sortable:true,
  cellClass:'px-2 custom-column-group-cell',
  editable:false,
  resizable: true, 
  minWidth: 180, flex:1,
  cellRenderer: TextRendererComponent,
},
{ headerName: "Commission Group", 
  headerClass: "px-1 custom-column-group-cell border-0 text-gray-color f-14 text-gray-color font-semibold",        
  field: 'commissionGroupName',
  sortable:true,
  cellClass:'px-2 custom-column-group-cell',
  editable:false,
  resizable: true, 
  minWidth: 180, flex:1,
  cellRenderer: NumericCellRendererComponent,
},
{ headerName: 'Commission %', 
  sortable:true,
  headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
  field: 'commissionPercent', 
  cellClass:'px-2 custom-column-group-cell text-end',
  editable:false,
  resizable: true, 
  minWidth: 180, flex:1,
  cellRenderer: TextRendererComponent,
},
{ headerName: "Status", 
  headerCheckboxSelection: false, 
  headerClass: "custom-column-group-cell px-0",
  field: 'active',  
  sortable:true, 
  cellRenderer: CheckboxRendererComponent,
  cellRendererParams: { showLabel: false,isReadOnly:true }, 
  cellClass:'px-2 custom-column-group-cell d-flex justify-content-center',
  resizable: false,  
  editable:false,
  minWidth: 75, 
  maxWidth:75 ,
},
 {
  headerName: "",
  field: "Delete",
  resizable: true,
  minWidth: 60,
  maxWidth: 60,
  pinned: 'right',
  editable: false,
  cellRenderer: EditDeleteIconComponent ,
  cellRendererParams: (params: any) => {
    const storageService = new StorageService();
    const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
    return {
      hasDeletePermission: userPermissions?.mastersCanDelete,
      focusOnColumn:'name' ,isEditRowOnEdit:false
    };
  },
  headerComponentParams: {deleteThroughApi : true },
  cellClass: 'mx-0 custom-column-group-cell d-flex align-items-center justify-content-center',
  headerClass: "px-0 custom-column-group-cell",
},
];

const ExchangeRateListColumnDef: AgColDefsI[] = [
  { headerName: "Metal", 
    headerComponentParams: {enableMenu:false},
    sortable:true,
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'metal',
    cellClass:'px-0 custom-column-group-cell text-primary', 
    editable:false,
    lockPosition:true,
    suppressMovable: false,
    resizable: true, 
    cellRenderer: TextRendererComponent,
    cellRendererParams :{isCursor:true},
    minWidth: 80, flex:2,
  },
  { headerName: "Unit", 
    headerClass: "px-1 custom-column-group-cell border-0 text-gray-color f-14 text-gray-color font-semibold",        
    field: 'unit',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell',
    minWidth: 80, flex:2,
    editable:false,
    resizable: true,
    cellRenderer: TextRendererComponent,
  },
  { headerName: "Currency", 
    headerClass: "px-1 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
    field: 'currency',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell', minWidth: 80,flex:2,
    editable:false,
    resizable: true,
    cellRenderer:NumericCellRendererComponent,
  },
  
  // 
  { headerName: "Date", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'date',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    minWidth: 60,
    editable:false,
    resizable: true,
    cellRenderer: DateCellRendererComponent,
    cellRendererParams :{date: true},
  },
  { headerName: "Ounce Rate", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'ounceRate',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    minWidth: 80,flex:2,
    editable:false,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isRate:true},
  },
  { headerName: "Rate", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'currencyRate',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    minWidth: 80,flex:2,
    editable:false,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isRate:true},
  },
  { headerName: "Unit Conversion Rate", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'unitConversionRate',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    minWidth: 80,flex:2,
    editable:false,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isRate:true},
  },
  { headerName: "Metal Rate", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'metalRate',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    minWidth: 80,flex:2,
    editable:false,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isRate:true},
  },
  { headerName: "Metal Rate AED Per Gram", 
    headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold ag_header_end",
    field: 'metalRateInPerGram',
    sortable:true,
    cellClass:'px-2 custom-column-group-cell text-end',
    minWidth: 80,flex:2,
    editable:false,
    resizable: true,
    cellRenderer: NumericCellRendererComponent,
    cellRendererParams: {isRate:true},
  },
  // {
  //   headerName: "",
  //   field: "",
  //   resizable: true,
  //   minWidth: 60,
  //   maxWidth: 60,
  //   pinned: 'right',
  //   editable: false,
  //   cellClass:'d-flex justify-content-center align-items-center',
  //   cellRenderer: EditDeleteIconComponent ,
  //   cellRendererParams: (params: any) => {
  //     const storageService = new StorageService();
  //     const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
  //     return {
  //       hasDeletePermission: userPermissions?.mastersCanDelete,
  //       focusOnColumn:'name' ,isEditRowOnEdit:false
  //     };
  //   }
  // }
  ];
  

export const AgGridDataModelCreditCardList: AgGridI = {
  colDefs: CreditCardListColumnDef,
  rowSelection: "multiple",
  storageName : StorageName.ADMINISTRATION_MASTERS_CREDITCARD_GRID,
  rowHeight:28,
}

export const AgGridDataModelStyleList: AgGridI = {
  colDefs: StyleListColumnDef,
  rowSelection: "multiple",
  storageName : StorageName.ADMINISTRATION_MASTERS_STYLES_GRID,
  rowHeight:28,
}


export const AgGridDataModelBranchesList: AgGridI = {
    colDefs: BranchesListColumnDef,
    rowSelection: "multiple",
    storageName : StorageName.ADMINISTRATION_MASTERS_BRANCHES_GRID,
    rowHeight:28,
}


export const AgGridDataModelBucketList: AgGridI = {
    colDefs: BucketListColumnDef,
    rowSelection: "multiple",
    storageName : StorageName.ADMINISTRATION_MASTERS_BUCKET_GRID,
    rowHeight:28,
}

export const AgGridDataModelCategoryList: AgGridI = {
    colDefs: CategoryListColumnDef,
    rowSelection: "multiple",
    storageName : StorageName.ADMINISTRATION_MASTERS_CATEGORY_GRID,
    filterStorageName: StorageName.FILTER_ADMINISTRATION_MASTERS_CATEGORY_GRID,
    sortStorageName: StorageName.SORT_ADMINISTRATION_MASTERS_CATEGORY_GRID,
    paginationStorageName: StorageName.PAGINATION_ADMINISTRATION_MASTERS_CATEGORY_GRID,
    rows: [],
    rowHeight:28,
    isFilter: true,
    apiUrl: API_URL_GET_ALL_MASTERS_CATEGORY,
    isServerSidepagination: true,
    showPagination: true
}


export const AgGridDataModelTaxSettingList: AgGridI = {
  colDefs: TaxSettingListColumnDef,
  rowSelection: "multiple",
  storageName : StorageName.ADMINISTRATION_MASTERS_TAXSETTING_GRID,
  sortStorageName: StorageName.SORT_SETTING_ADMINISTRATION_MASTERS_TAXSETTING_GRID,
  rowHeight:28,
}

export const AgGridDataModelExchangeRateList: AgGridI = {
  colDefs: ExchangeRateListColumnDef,
  rowSelection: "multiple",
  storageName : StorageName.ADMINISTRATION_MASTERS_EXCHANGERATE_GRID,
  rowHeight:28,
}

const Metal: AgColDefsI = {
  headerName: "Metal",
  field: 'metalName',
  headerClass: "px-0 custom-column-group-cell",
  cellClass: 'px-2 text-start custom-column-group-cell',
  minWidth: 130,
  flex: 1,
  cellRenderer: TextRendererComponent,
  sortable: false,
  suppressMovable: false,
  editable: false,
};
const Carat: AgColDefsI = {
  headerName: "Carat",
  field: 'caratName',
  headerClass: "px-0 custom-column-group-cell",
  cellClass: 'custom-column-group-cell text-primary',
  minWidth: 130,
  flex: 1,
  cellRenderer: TextRendererComponent,
  cellRendererParams: { isCursor: true },
  sortable: false,
  suppressMovable: false,
  editable: false,
};
const CurrentRateColumn: AgColDefsI = {
  headerName: "Current Rate",
  field: "currentRate",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  resizable: true,
  cellStyle: { 'text-align': 'right' },
  headerClass: "custom-column-group-cell ag_header_end px-0",
  cellClass: "custom-column-group-cell text-primary",
  editable: false,
  sortable: false,
  isRequired: true,
  cellRenderer:  TextRendererComponent,
  cellRendererParams: { isRate: true, isCursor: true },
};
// const OunceRateColumn: AgColDefsI = {
//   headerName: "Ounce Rate",
//   field: "ounceRate",
//   minWidth: AmountColWidth.MinWidth,
//   maxWidth: AmountColWidth.MaxWidth,
//   resizable: true,
//   cellStyle: { 'text-align': 'right' },
//   headerClass: "custom-column-group-cell ag_header_end px-0",
//   cellClass: "custom-column-group-cell",
//   editable: false,
//   sortable: false,
//   isRequired: true,
//   cellRenderer: NumericCellRendererComponent,
//   cellRendererParams: { isRate: true },
// };
const MetalExchangeRateColumn: AgColDefsI = {
  headerName: "Metal Exchange Rate",
  field: "metalExchangeRate",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  resizable: true,
  cellStyle: { 'text-align': 'right' },
  headerClass: "custom-column-group-cell ag_header_end px-0",
  cellClass: "custom-column-group-cell",
  editable: false,
  sortable: false,
  isRequired: true,
  cellRenderer:  TextRendererComponent,
  cellRendererParams: { isRate: true },
};
const ConversionRateColumn: AgColDefsI = {
  headerName: "Conversion Rate",
  field: "conversionRate",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  resizable: true,
  cellStyle: { 'text-align': 'right' },
  headerClass: "custom-column-group-cell ag_header_end px-0",
  cellClass: "custom-column-group-cell",
  editable: false,
  sortable: false,
  isRequired: true,
  cellRenderer:  TextRendererComponent,
  cellRendererParams: { isRate: true },
};
const SellPremiumColumn: AgColDefsI = {
  headerName: "Sell Premium",
  field: "sellPremium",
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  resizable: true,
  cellStyle: { 'text-align': 'right' },
  headerClass: "custom-column-group-cell ag_header_end px-0",
  cellClass: "custom-column-group-cell",
  editable: false,
  sortable: false,
  isRequired: true,
  cellRenderer:  TextRendererComponent,
  cellRendererParams: { isRate: true },
};
const DeleteColumn: AgColDefsI = {
  headerName: "",
  editable: false,
  field: 'editdeleteicon',
  cellRenderer: EditDeleteIconComponent,
  cellClass: ' custom-column-group-cell d-flex align-items-center justify-content-center',
  headerComponentParams: {deleteThroughApi : true },
  lockPosition: 'right',
  suppressMovable: false,
  resizable: false,
  minWidth: 50,
  maxWidth: 50
}
const Activecolumn: AgColDefsI = { 
  headerName: "", 
  headerCheckboxSelection: false, 
  headerClass: "px-1 custom-column-group-cell",
  field: 'active',
  lockPosition: 'right',
  editable:false,
  sortable:false,
  suppressMovable: false,
  cellRenderer: CheckboxRendererComponent,
  cellRendererParams: { showLabel: false,isReadOnly:true }, 
  cellClass:'custom-column-group-cell font-regular px-1', 
  minWidth: 50,
  maxWidth: 50,
  resizable:false,
}

export const RateconversionColumnDef: AgColDefsI[] = [
  Metal,
  Carat,
  CurrentRateColumn,
  // OunceRateColumn,
  MetalExchangeRateColumn,
  ConversionRateColumn,
  SellPremiumColumn,
  DeleteColumn,
  Activecolumn
];
export const AgGridDataModelRateconversionList: AgGridI = {
  colDefs: RateconversionColumnDef,
  rowSelection: "multiple",
  storageName: StorageName.ADMINISTRATION_MASTERS_RATE_CONVERSION_GRID,
  rowHeight: 28,
}

export enum MasterModalTitle{
  AddBranchDetail  = "Branch Details",
  EditBranchDetail = "Edit Branch Details",
  AddBucket        = "Add Bucket",
  EditBucket       = "Edit Bucket",
  AddTaxSetting    = "Add Tax",
  EditTaxSetting   = "Edit Tax",
  AddCreditCard    = "Credit Card",
  EditCreaditCard  = "Edit Credit Card",
  AddExchangeRate   = "Exchange Rate",
  EditExchangeRate  = "Edit Exchange Rate",
  AddMetalRate     = "Add Metal Rate",
  UpdateMetalRate  = "Update Metal Rate",
  AddCategory      = "Add Category",
  EditCategory     = "Edit Category",
}

// branch region start 
export class CreateUpdateBranchRequestModel{
  id              : number;
  name?           : string;
  active?         : boolean = true;
  addressId?      : number;
  addressLine1?   : string|null;
  addressLine2?   : string|null;
  email?          : string|null;
  countryId       : any;
  stateId?        : number;
  districtId?     : number;
  talukaId?       : number;
  pinCode?        : number;
  mobileNumber1   : number|null;
  mobileNo1DialCode : string|null;
  mobileNumber2   : number|null;
  mobileNo2DialCode: string|null;
  isSystemGenerated : boolean;
}  

export class BranchMainModel {
  branchModel: CreateUpdateBranchRequestModel;
  cloneDataModel: CloneDataModel;
}

export class CloneDataModel {
  branchId: number;
  cloneTableNames: string[];
}

export class GetDistrictData{
  id              : number;
  name?           : string;
}

// CreditCard region start
export class CreateUpdateCreditCardRequestModel{
  id                  : number;
  name?               : string;
  active?             : boolean = true;
  accountLedgerId?    : number;
  AccountLedgerName?  : string;
  commissionGroup?    : number;
  CommissionGroupName?: string;
  commissionPercent?  : number;
}
export class GetAllCreditCardrequestModel extends paginationModel{
  exportRequest : exportRequest[];
  getAll = true ;
}

// bucket region start
export class CreateUpdateBucketRequestModel{
  id              : number;
  name?           : string;
  active?          : boolean = true;
  barcodeNo?       : number;
  minimumQuantity? : number;
  maximumQuantity? : number;
  minimumWeight?   : number;
  maximumWeight?   : number;
  weight?          : number;
}

 // TaxSetting Model
 export class CreateUpdateTaxSettingRequestModel{
  id?              : number;
  name             : string;
  active?          : boolean = true;
  applicableOn     : number;
  comment?         : string ;
  rate?            : number = 0;
  calculationMode? : number;
  isStateWise?     : boolean;
  isEdit?          : boolean = false;
  taxGroupId?      : number ;
}

// export class insertUpdateCategoryRequestModel{
//   id?             : number;
//   name            : string;
//   active?         : boolean = true;
//   parentCategoryId?: number;
//   parentCategoryName?: string;
// }

export enum MasterTab {
  Masters               = 1,      
  Branch                = 2,
  Bucket                = 3,
  TaxSetting            = 4,
  Style                 = 5,
  UserDefined           = 6,           
  CreditCard            = 7,           
  ExchangeRate          = 8,  
  RateConversion        = 9,
  Category              = 10,
  Diamondstonepricing   = 11,
  MakingLabourPricing   = 12,
}

export class CompanyDropdownModelList{

}
export class StateDropdownModelList{

}

const ProductNameColumn: AgColDefsI = {
  headerName: "Product Name", 
  headerComponentParams: {enableMenu:false},
  sortable:true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'productName',
  cellClass:'px-0 custom-column-group-cell text-primary', 
  editable:false,
  lockPosition:true,
  suppressMovable: false,
  resizable: true,
  cellRenderer: TextRendererComponent,
  cellRendererParams :{isCursor:false},
  minWidth: 90, flex:2,
}

const ShortCodeColumn: AgColDefsI = { 
  headerName: "Short Code", 
  headerComponentParams: {enableMenu:false},
  sortable:true,
  headerClass: "px-0 custom-column-group-cell border-0 f-14 text-gray-color font-semibold",
  field: 'shortCode',
  cellClass:'px-0 custom-column-group-cell', 
  editable:false,
  lockPosition:true,
  suppressMovable: false,
  resizable: true,
  cellRenderer: TextRendererComponent,
  minWidth: 70, flex:1,
}

export const ColDefsMappedProducts: AgColDefsI[] = [
 ProductNameColumn,
 ShortCodeColumn
];
export const AgGridDataModelMappedProducts: AgGridI = {
  colDefs: ColDefsMappedProducts,
  storageName:StorageName.ADMINISTRATION_CATEGORY_MAPPED_PRODUCTS_GRID,
  filterStorageName: StorageName.FILTER_ADMINISTRATION_CATEGORY_MAPPED_PRODUCTS_GRID,
  sortStorageName: StorageName.SORT_ADMINISTRATION_CATEGORY_MAPPED_PRODUCTS_GRID,
  paginationStorageName: StorageName.PAGINATION_ADMINISTRATION_CATEGORY_MAPPED_PRODUCTS_GRID,
  rowSelection: "multiple",
  rowHeight:28,
  isServerSidepagination: true,
  showPagination: true
};

export const Color: AgColDefsI = {
  headerName: "Color",
  field: "colorId",
  minWidth: 100,
  sortable: true,
  editable: true,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.COLOR_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const Shape: AgColDefsI = {
  headerName: "Shape",
  field: "shapeId",
  minWidth: 100,
  sortable: true,
  editable: true,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.SHAPE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const SeiveSize: AgColDefsI = {
  headerName: "SeiveSize",
  field: "seiveSizeId",
  minWidth: 100,
  sortable: true,
  editable: true,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.SEIVE_SIZE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const Clarity: AgColDefsI = {
  headerName: "Clarity",
  field: "clarityId",
  minWidth: 100,
  sortable: true,
  editable: true,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.CLARITY_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const CalculationTypeColumn: AgColDefsI = {
  headerName: "Calculation Type",
  field: "calculationType",
  minWidth: 100,
  sortable: true,
  editable: true,
  lockPinned: false,
  suppressMovable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  headerComponentParams: { enableSorting: false },
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.CALCULATION_TYPE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
export const ProductColumn: AgColDefsI = {
  headerName: "Product",
  field: "productId",
  colId: 'productId',
  minWidth: 200,
  maxWidth: 200,
  sortable: true,
  editable: true,
  headerComponentParams: { isRequired: true ,filterParams: StorageName.DIAMOND_PRODUCT_DROPDOWN,},
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomSelect2Component,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.DIAMOND_PRODUCT_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const CaratFromColumn: AgColDefsI = {
  headerName: "Carat From",
  headerComponentParams: { enableMenu: false },
  sortable: true,
  headerClass: "px-0 custom-column-group-cell ag_header_end",
  field: 'caratFrom',
  cellClass: 'px-0 custom-column-group-cell text-end',
  editable: true,
  resizable: true,
  cellRenderer: TextRendererComponent,
   cellEditor:AgGridCustomInputComponent,
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  },
  minWidth: 70, flex: 1,
}

const CaratToColumn: AgColDefsI = {
  headerName: "Carat To",
  headerComponentParams: { enableMenu: false },
  sortable: true,
  headerClass: "px-0 custom-column-group-cell ag_header_end",
  field: 'caratTo',
  cellClass: 'px-0 custom-column-group-cell text-end',
  editable: true,
  resizable: true,
  cellRenderer: TextRendererComponent,
   cellEditor:AgGridCustomInputComponent,
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  },
  minWidth: 70, flex: 1,
}

const SellingRateColumn: AgColDefsI = {
  headerName: "Selling Rate",
  headerComponentParams: { enableMenu: false },
  sortable: true,
  headerClass: "px-0 custom-column-group-cell ag_header_end",
  field: 'sellingRate',
  cellClass: 'px-0 custom-column-group-cell text-end',
  editable: true,
  resizable: true,
   cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
  },
  minWidth: 70, flex: 1,
}

export const ColDefsDiamondStonePricing: AgColDefsI[] = [
  ProductColumn,
  Color,
  Shape,
  SeiveSize,
  Clarity,
  CalculationTypeColumn,
  CaratFromColumn,
  CaratToColumn,
  SellingRateColumn
];

export const AgGridDataModelDiamondStonePricing: AgGridI = {
  colDefs: ColDefsDiamondStonePricing,
  storageName: StorageName.ADMINISTRATION_DIAMOND_STONE_PRICING_GRID,
  rowSelection: "multiple",
  rowHeight: 28,
};

export const ColorNameColumn: AgColDefsI = {
  headerName: "Color",
  field: "color",
  minWidth: 100,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.COLOR_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const ShapeNameColumn: AgColDefsI = {
  headerName: "Shape",
  field: "shape",
  minWidth: 100,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.SHAPE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const SeiveSizeNameColumn: AgColDefsI = {
  headerName: "SeiveSize",
  field: "seiveSize",
  minWidth: 100,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.SEIVE_SIZE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const ClarityNameColumn: AgColDefsI = {
  headerName: "Clarity",
  field: "clarity",
  minWidth: 100,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.CLARITY_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const CalculationTypeColumnName: AgColDefsI = {
  headerName: "Calculation Type",
  field: "calculationType",
  minWidth: 100,
  sortable: true,
  editable: false,
  lockPinned: false,
  suppressMovable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  headerComponentParams: { enableSorting: false },
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.CALCULATION_TYPE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
export const ProductColumnName: AgColDefsI = {
  headerName: "Product",
  field: "product",
  minWidth: 110,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.PRODUCT_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const CaratFromNameColumn: AgColDefsI = {
  headerName: "Carat From",
  headerComponentParams: { enableMenu: false },
  sortable: true,
  headerClass: "px-0 custom-column-group-cell ag_header_end",
  field: 'caratFrom',
  cellClass: 'px-0 custom-column-group-cell text-end',
  editable: false,
  resizable: true,
  cellRenderer:NumericCellRendererComponent,
  cellRendererParams: {isWeight:true},
  minWidth: 70, flex: 1,
}

const CaratToNameColumn: AgColDefsI = {
  headerName: "Carat To",
  headerComponentParams: { enableMenu: false },
  sortable: true,
  headerClass: "px-0 custom-column-group-cell ag_header_end",
  field: 'caratTo',
  cellClass: 'px-0 custom-column-group-cell text-end',
  editable: false,
  resizable: true,
  cellRenderer:NumericCellRendererComponent,
  cellRendererParams: {isWeight:true},
  minWidth: 70, flex: 1,
}

const SellingRateNameColumn: AgColDefsI = {
  headerName: "Selling Rate",
  headerComponentParams: { enableMenu: false },
  sortable: true,
  headerClass: "px-0 custom-column-group-cell ag_header_end",
  field: 'sellingRate',
  cellClass: 'px-0 custom-column-group-cell  text-end',
  editable: false,
  resizable: true,
  cellRendererParams: {isRate:true},
  cellRenderer:NumericCellRendererComponent,
  minWidth: 70, flex: 1,
}
const ActionColumn: AgColDefsI =
{
  headerName: "",
  field: 'editDelete',
  cellRenderer: EditDeleteIconComponent,
  cellClass: "custom-column-group-cell d-flex align-items-center justify-content-center",
  headerClass:"justify-content-center px-0 custom-column-group-cell border-0",
  minWidth: 80,
  maxWidth: 80,
  editable: false,
  headerComponentParams: { deleteThroughApi: true },
  flex: 1,
  lockPinned: true,
  lockPosition: 'right',
  suppressMovable: false,
  cellRendererParams: {
    editIcon: true,
  },
}

export const ColDefsDiamondStonePricingList: AgColDefsI[] = [
  ProductColumnName,
  ColorNameColumn,
  ShapeNameColumn,
  SeiveSizeNameColumn,
  ClarityNameColumn,
  CalculationTypeColumnName,
  CaratFromNameColumn,
  CaratToNameColumn,
  SellingRateNameColumn,
  ActionColumn
];

export const AgGridDataModelDiamondStonePricingList: AgGridI = {
  colDefs: ColDefsDiamondStonePricingList,
  rowSelection: "multiple",
  columnSettings: true,
  paginationStorageName: StorageName.PAGINATION_ADMINISTRATION_DIAMOND_STONE_PRICING_LIST_GRID,
  storageName: StorageName.ADMINISTRATION_DIAMOND_STONE_PRICING_LIST_GRID,
  filterStorageName: StorageName.FILTER_ADMINISTRATION_DIAMOND_STONE_PRICING_LIST_GRID,
  sortStorageName: StorageName.SORT_ADMINISTRATION_DIAMOND_STONE_PRICING_LIST_GRID,
  rowHeight: 28,
  singleClickEdit: true,
  rows: [],
  isServerSidepagination: true,
  apiUrl: API_URL_GET_ALL_DIAMONDSTONEPRICING,
  showPagination: true
};


export const MakingTypeColumn: AgColDefsI = {
  headerName: "Product",
  field: "product",
  minWidth: 110,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.MAKINGCHARGESTYPE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const WtFromColumn: AgColDefsI = {
  headerName: "Wt. From",
  field: "WtFrom",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell",
  editable: true,
  sortable: true,
  lockPinned: false,
  suppressMovable: false,
  cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  headerComponentParams: { enableSorting: false},
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  }
}
const WtToColumn: AgColDefsI = {
  headerName: "Wt. To",
  field: "wtTo",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell",
  editable: true,
  sortable: true,
  lockPinned: false,
  suppressMovable: false,
  cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  headerComponentParams: { enableSorting: false},
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  }
}
export const RateColumn: AgColDefsI = {
  headerName: "Rate",
  field: "rate",
  minWidth: 100,
  headerComponentParams: { isRequired: true ,enableSorting: false},
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell",
  editable: true,
  sortable: true,
  isRequired:false,
  lockPinned: false,
  suppressMovable: false,
  cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
  }
};



export const ProductMakingLabourPricingColumn: AgColDefsI = {
  headerName: "Product",
  field: "productId",
  colId: 'productId',
  minWidth: 200,
  maxWidth: 200,
  sortable: false,
  editable: true,
  headerComponentParams: { isRequired: false ,filterParams: StorageName.PRODUCT_DROPDOWN,},
  cellRenderer: TextRendererComponent,
 cellEditor: AgGridCustomSelect2Component,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.PRODUCT_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
export const MakingTypeMakingLabourPricingColumn: AgColDefsI = {
  headerName: "Making Type",
  field: "makingTypeId",
  minWidth: 110,
  sortable: false,
  editable: true,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellEditorParams: {
    values: () => {
      const storageService = new StorageService();
      const storage = StorageName;
      return storageService.retrieve(storage.MAKINGCHARGESTYPE_DROPDOWN);
    },
  },
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const WtFromMakingLabourPricingColumn: AgColDefsI = {
  headerName: "Wt. From",
  field: "weightFrom",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell text-end",
  editable: true,
  sortable: true,
  cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  headerComponentParams: { enableSorting: false},
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  }
}
const WtToMakingLabourPricingColumn: AgColDefsI = {
  headerName: "Wt. To",
  field: "weightTo",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell text-end",
  editable: true,
  sortable: true,
  cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  headerComponentParams: { enableSorting: false},
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  }
}
export const RateMakingLabourPricingColumn: AgColDefsI = {
  headerName: "Rate",
  field: "rate",
  headerComponentParams: { isRequired: true ,enableSorting: false},
  headerClass: "custom-column-group-cell px-0",
  cellClass: "custom-column-group-cell text-end",
  editable: true,
  sortable: true,
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  isRequired:true,
  cellRenderer: TextRendererComponent,
  cellEditor:AgGridCustomInputComponent,
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:10
  }
};
export const ColDefsMakingLabourPricing: AgColDefsI[] = [
  ProductMakingLabourPricingColumn,
  MakingTypeMakingLabourPricingColumn,
  WtFromMakingLabourPricingColumn,
  WtToMakingLabourPricingColumn,
  RateMakingLabourPricingColumn,
];

export const AgGridDataModelMakingLabourPricing: AgGridI = {
  colDefs: ColDefsMakingLabourPricing,
  storageName: StorageName.ADMINISTRATION_MASTERS_MAKING_PRICING_GRID,
  rowSelection: "multiple",
  rowHeight: 28,
};



export const ProductMakingLabourPricingListColumn: AgColDefsI = {
  headerName: "Product",
  field: "productName",
  minWidth: 110,
  sortable: true,
  editable: false,
  headerComponentParams: { isRequired: false},
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
export const MakingTypeMakingLabourPricingListColumn: AgColDefsI = {
  headerName: "Making Type",
  field: "makingTypeName",
  minWidth: 110,
  sortable: true,
  editable: false,
  cellRenderer: TextRendererComponent,
  cellEditor: AgGridCustomDropdownComponent,
  cellClass: "custom-column-group-cell px-0",
  headerClass: "custom-column-group-cell px-0",
};
const WtFromMakingLabourPricingListColumn: AgColDefsI = {
  headerName: "Wt. From",
  field: "weightFrom",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0 ag_header_end",
  cellClass: "custom-column-group-cell text-end",
  editable: false,
  sortable: true,
  cellRenderer:NumericCellRendererComponent,
  headerComponentParams: { enableSorting: false},
  cellRendererParams: {isWeight:true},
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  }
}
const WtToMakingLabourPricingListColumn: AgColDefsI = {
  headerName: "Wt. To",
  field: "weightTo",
  minWidth: WeightColWidth.MinWidth,
  maxWidth: WeightColWidth.MaxWidth,
  headerClass: "custom-column-group-cell px-0 ag_header_end",
  cellClass: "custom-column-group-cell text-end",
  editable: false,
  sortable: true,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: {isWeight:true},
  headerComponentParams: { enableSorting: false},
  cellEditorParams:{
    decimalPlaces:3,
    isOnlyNumbers:true,
    inputMaxlength:8
  }
}
export const RateMakingLabourPricingListColumn: AgColDefsI = {
  headerName: "Rate",
  field: "rate",
  headerComponentParams: { isRequired: false ,enableSorting: false},
  headerClass: "custom-column-group-cell px-0 ag_header_end",
  cellClass: "custom-column-group-cell text-end",
  editable: false,
  sortable: true,
  minWidth: AmountColWidth.MinWidth,
  maxWidth: AmountColWidth.MaxWidth,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: {isRate:true},
  cellEditorParams:{
   decimalPlaces:3,
   isOnlyNumbers:true,
   inputMaxlength:10
  }
};
export const ColDefsMakingLabourPricingList: AgColDefsI[] = [
  ProductMakingLabourPricingListColumn,
  MakingTypeMakingLabourPricingListColumn,
  WtFromMakingLabourPricingListColumn,
  WtToMakingLabourPricingListColumn,
  RateMakingLabourPricingListColumn,
  ActionColumn
];

export const AgGridDataModelMakingLabourPricingList: AgGridI = {
  colDefs: ColDefsMakingLabourPricingList,
  storageName: StorageName.ADMINISTRATION_MASTERS_MAKING_LABOURE_PRICING_PRODUCTLIST_GRID,
  sortStorageName: StorageName.SORT_ADMINISTRATION_MASTERS_MAKING_LABOURE_PRICING_PRODUCTLIST_GRID,
  filterStorageName: StorageName.FILTER_ADMINISTRATION_MASTERS_MAKING_LABOURE_PRICING_PRODUCTLIST_GRID,
  paginationStorageName: StorageName.PAGINATION_ADMINISTRATION_MASTERS_MAKING_LABOURE_PRICING_PRODUCTLIST_GRID,
  rowSelection: "multiple",
  rowHeight: 28,
  singleClickEdit: true,
  rows: [],
  apiUrl: API_URL_GET_ALL_MAKING_LABOUR_PRICING,
  isServerSidepagination: true,
  showPagination: true,
};

export class ApiRequestModelMakingLabourPricingList extends paginationModel {
  pageSize: number = 25;
  branchId: number;
  exportAs: number;
  exportRequest: exportRequest[];
  fromDate: string;
  toDate: string;
  filters:any;
}